export default function InputText({ id, labelText, inputValue, changeHandler }) {
  return (
    <div id={id + "Input"} className="form-input-container">
      <label className="form-label" htmlFor={"text-" + id + "Input"}>{labelText} </label>
      <div className="form-item-container">
        <input
          className="form-item form-input"
          id={"text-" + id + "Input"}
          type="text"
          value={inputValue}
          size="30"
          maxLength="128"
          onChange={changeHandler}
        ></input>
      </div>
    </div>
  );
}
